import React, {useState, useContext, useEffect} from "react";
import { API_BASE_URL } from '../dppApi';
import { useNavigate } from 'react-router-dom';
import JewelleryCard from "./JewelleryCard";
import bracelet from "../images/bracelet.jpeg"
import brooch from "../images/brooch.jpeg"
import earrings from "../images/earrings.jpg"
import diamondNecklace from "../images/diamond-necklace.jpg"
import pearlNecklace from "../images/pearl-necklace.jpg"
import loveBracelet from "../images/gold-bracelet.jpg"
import uploadPhoto from "../images/upload-photo.jpg"
import { AuthContext } from './AuthProvider';
import NavBar from './NavBar.js';
import UploadPhotoCard from "./UploadPhotoCard.js";



const staticCatalog = [
    {
        key: 1,
        picture: bracelet,
        description: "Bracelet",
        metal: "925 Silver",
        stone: [],
        brand: "Tiffany & Co.",
        datePurchased: "Mar 14, 2024",
        storageLocation: "BoFA San Francisco"

    },
    {
        key: 2,
        picture: brooch,
        description: "Brooch",
        metal: "18K Yellow Gold",
        stone: [], 
        brand: "Tiffany & Co.",
        datePurchased: "Sep 25, 2025",
        storageLocation: "BoFA San Francisco"

    },
    {   
        key: 3,
        picture: earrings,
        description: "Earrings",
        metal: "18K White Gold",
        stone: ["Pink Sapphire"],
        brand: "Harry Winston",
        datePurchased: "Aug 11, 2022",
        storageLocation: "HDFC Mumbai"

    },
    {   
        key: 4,
        picture: diamondNecklace,
        description: "Diamond Necklace",
        metal: "Platinum",
        stone: ["Diamonds VVS"],
        brand: "Harry Winston",
        datePurchased: "Jan 19, 2005",
        storageLocation: "BoFA San Francisco"

    },
    {
        key: 5,
        picture: pearlNecklace,
        description: "Pearl Necklace",
        metal: "",
        stone: ["Akoya cultured freshwater pearls"],
        brand: "Mikimoto",
        datePurchased: "May 4, 2008",
        storageLocation: "Home"

    },
    {
        key: 6,
        picture: loveBracelet,
        description: "Gold Bracelet",
        metal: "Gold",
        stone: [],
        brand: "Cartier",
        datePurchased: "Oct 20, 2025",
        storageLocation: "BoFA San Francisco"

    }]


const CatalogJewellery = () => {

    const {user, isAuthenticated, accessToken} = useContext(AuthContext);
    const navigate = useNavigate();

    const [catalog, setCatalog] = useState([]);
    const [firstImage, setFirstImage] = useState(null);
    
    // TODO: Send the access token and/or move the authentication to the backend
    useEffect(() => {
        //fetch("http://ec2-54-167-84-208.compute-1.amazonaws.com:5000/api/get-jewellery", {
        fetch(`${API_BASE_URL}/api/get-jewellery`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${user}`,
            }
        })
        .then(res => res.json())
        .then(data => setCatalog(data))
    }, [])
        

    if (!isAuthenticated) {
        return
    }
    
    return ( 
        
        <div>
        <NavBar/>
        <div className="empty-div-50"></div>
        <div className="grid-container">
        {  
        catalog.map(item => 
            <JewelleryCard 
                picture={item.image} 
                description={item.description ? item.description : ""} 
                datePurchased={item.datePurchased ? item.datePurchased : ""} 
                storageLocation={item.storageLocation ? item.storageLocation : ""}
                itemKey={item.key}/>)
        }
        <UploadPhotoCard picture={uploadPhoto}></UploadPhotoCard>
        </div>
        <div className="empty-div-30"></div>
        </div>


    );

};

export default CatalogJewellery;